(function () {
    'use strict';
    angular.module('Services').factory('ClientsNetworkTable', ClientsNetworkTable);

    ClientsNetworkTable.$inject = [
        '$q', '$location', 'ClientService', 'TableLiteFactory', 'toastr', 'ConfirmationModalFactory', 'AsyncRecursion'
    ];

    function ClientsNetworkTable($q, $location, ClientService, TableLiteFactory, toastr, ConfirmationModalFactory, AsyncRecursion) {
        return function (bridge) {
            const networkEnableSharingConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.enableToNetwork.MESSAGE',
                code: 'messages.warning.enableToNetwork.CODE',
            });
            const networkDisableSharingConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.disableToNetwork.MESSAGE',
                code: 'messages.warning.disableToNetwork.CODE',
            });
            const companiesListTableData = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-success',
                        label: 'Enable',
                        tooltip: 'Enable selected company\'s network effect',
                        onClick: function (row) {
                            const btn = this;
                            networkEnableSharingConfirmation.getInstance().result.then(cond => {
                                if (!cond)
                                    return false;
                                btn.label = 'Enabling...';
                                companiesListTableData.fetching = true;
                                const selected = companiesListTableData.data.filter(item => {
                                    return item.isSelected;
                                });
                                if (!selected.length) {
                                    toastr.error('There are no selected reseller', 'Unable to perform operation');
                                    return;
                                }
                                ClientService.Reseller.enableToNetworkEffect(selected.map(reseller => reseller.id),
                                    data => {
                                        btn.label = 'Enable';
                                        companiesListTableData.fetching = false;
                                        toastr.success(`Successfully enabled selected resellers`);
                                        sendRequest();
                                    }, error => {
                                        btn.label = 'Enable';
                                        companiesListTableData.fetching = false;
                                        toastr.error(`Failed to enable selected resellers`);
                                    }
                                )
                            });
                        }
                    }, {
                        class: 'btn-danger',
                        label: 'Disable',
                        tooltip: 'Disable selected company\'s network effect',
                        onClick: function () {
                            const btn = this;
                            networkDisableSharingConfirmation.getInstance().result.then(cond => {
                                if (!cond)
                                    return false;
                                btn.label = 'Disabling...';
                                companiesListTableData.fetching = true;
                                const selected = companiesListTableData.data.filter(item => {
                                    return item.isSelected;
                                });
                                if (!selected.length) {
                                    toastr.error('There are no selected reseller', 'Unable to perform operation');
                                    return;
                                }
                                ClientService.Reseller.disableToNetworkEffect(selected.map(reseller => reseller.id), counts =>{
                                    btn.label = 'Disable';
                                    companiesListTableData.fetching = false;
                                    toastr.success(`Successfully disabled selected resellers`);
                                    sendRequest();
                                }, error => {
                                    btn.label = 'Enable';
                                    companiesListTableData.fetching = false;
                                    toastr.error(`Failed to disable selected resellers`);
                                });
                            });
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'SELECT ALL',
                    class: 'text-center',
                    width: '70px',
                    viewName: 'checkAll',
                    filter: {
                        type: 'checkbox',
                        viewnName: 'enableDisable'
                    }
                }, {
                    label: 'Company Name',
                    viewName: 'linkName',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Network Enabled',
                    viewName: 'networkEnabledType',
                    filterName: 'networkEnabled',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model === 'Enabled') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Enabled by Reseller',
                    viewName: 'enableServiceSharingStatus',
                    filterName: 'reseller.enableServiceSharing',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model === 'Enabled') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Action',
                    viewName: 'action'
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(companiesListTableData,
                {
                    serviceCallback: ClientService.Reseller.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(angular.copy(data));
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 10,
                        page: 0,
                        sort: 'id,desc',
                        active: true
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function updateCompany(company, defer) {
                ClientService.Company.update(ClientService.Company.cleanPayload(company), function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                }, company.id);
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (client, index) {
                    client.phoneNumbers = {
                        type: 'multiLine',
                        list: []
                    };
                    client.id = client.id ? client.id : index;
                    client.companyNo = client.companyNo ? client.companyNo : 'N/A';
                    client.linkName = {
                        type: 'link',
                        label: client.name,
                        link: '/clients/company/details/' + client.id
                    };
                    client.contactPerson = client.primaryContact ? client.primaryContact.firstName + " " + client.primaryContact.lastName : 'N/A';
                    if (client.primaryContact) {
                        client.contactPerson = client.primaryContact.firstName + " " + client.primaryContact.lastName;

                        if (client.primaryContact.firstName == "" && client.primaryContact.lastName == "") {
                            client.contactPerson = "N/A";
                        }
                    }

                    client.email = client.email ? client.email : 'N/A';
                    if (client.phone1)
                        client.phoneNumbers.list.push(client.phone1);
                    if (client.phone2)
                        client.phoneNumbers.list.push(client.phone2);
                    if (!client.phone1 && !client.phone2)
                        client.phoneNumbers = 'N/A';

                    client.networkEnabledType = {
                        type: 'status',
                        status: client.networkEnabled,
                        label: client.networkEnabled ? 'Enabled' : 'Disabled'
                    };
                    client.enableServiceSharingStatus = {
                        type: 'status',
                        status: client.reseller && client.reseller.enableServiceSharing,
                        label: client.reseller && client.reseller.enableServiceSharing ? 'Enabled' : 'Disabled'
                    };
                    client.action = {
                        type: 'button',
                        buttons: [{
                            text: 'Shared Carrier Profiles',
                            tooltip: 'View reseller\'s shared carrier profiles',
                            icon: '',
                            class: 'btn-primary',
                            action: (item) => {
                                $location.path('/networking/' + item.id);
                            }
                        }, {
                            text: 'View reseller',
                            tooltip: 'View reseller details',
                            icon: '',
                            class: 'btn-primary',
                            action: (item) => {
                                $location.path('/clients/company/details/' + item.id);
                            }
                        }]
                    };
                    //client.href = '/clients/company/details/' + client.id;

                    companiesListTableData.data.push(client);
                });
                /*** END - Building of Data ***/
            };
            this.tableData = companiesListTableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/ClientsNetworkTable.js